// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InfoTooltip__trigger":"bcl_a bib_jb bib_qx bib_eg"};